import { createStore, StoreSnapshot } from '@xstate/store';

import { MappedProduct } from '@/fo/util/map-product-data';
export interface ContextStoreProductVariant {
  selectedProduct: MappedProduct | null;
  modal: {
    isOpen: boolean;
    product: MappedProduct | null;
  };
}

const initialContext: ContextStoreProductVariant = {
  selectedProduct: null,
  modal: {
    isOpen: false,
    product: null
  }
};

export const storeProductVariant = createStore({
  context: initialContext,
  on: {
    setSelectedProduct: (
      context: ContextStoreProductVariant,
      event: {
        product: MappedProduct;
      }
    ) => {
      return {
        ...context,
        selectedProduct: event.product
      };
    },
    openModal: (
      context: ContextStoreProductVariant,
      event: {
        product: MappedProduct;
      }
    ) => {
      return {
        ...context,
        modal: {
          isOpen: true,
          product: event.product
        }
      };
    },
    closeModal: (context: ContextStoreProductVariant) => {
      return {
        ...context,
        modal: {
          isOpen: false,
          product: null
        }
      };
    },
    reset: () => {
      return initialContext;
    }
  }
});

export const selectSelectedProduct = (
  state: StoreSnapshot<ContextStoreProductVariant>
) => {
  return state.context.selectedProduct;
};

export const selectModalState = (
  state: StoreSnapshot<ContextStoreProductVariant>
) => {
  return state.context.modal;
};
